// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2.5H9.48063L11.4806 5H23V10.5218C21.9897 9.875 20.7886 9.5 19.5 9.5C15.9101 9.5 13 12.4101 13 16V21H1V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.25 14.75C18.25 14.0596 18.8096 13.5 19.5 13.5C19.8441 13.5 20.1541 13.6377 20.3811 13.8634L21.0904 14.5683L22.5003 13.1498L21.791 12.4448C21.2045 11.8619 20.3936 11.5 19.5 11.5C17.7051 11.5 16.25 12.9551 16.25 14.75V15.5H14.999V22H23.999V15.5H18.25V14.75Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-unlocked-filled')
export default class FolderUnlockedFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-unlocked-filled',
    }
  }
}
